// the Inbox (R10-Q16).
export const inbox = {
  // the reading pane
  readingPane: "Reading pane",
  pickItem: "Pick an item to read it here.",
  openInConversation: "Open in conversation",
  copyLink: "Copy link",
  linkCopied: "Link copied",
  them: "them",
  replyGoesBack:
    "Your reply goes back to {name}, where they asked. Start with “Vantage,” to ask Vantage instead.",
  replyTo: "Reply to {name}",
  replyToPlaceholder: "Reply to {name}…",
  replyToVantage: "Reply to Vantage",
  askFollowUp: "Ask a follow-up…",
  messageGone: "This message isn't available",
  mayBeDeleted: "It may have been deleted.",
  answerInReport: "The answer comes in the report's conversation.",
  // the filter chips
  filterAll: "All",
  filterUnread: "Unread",
  filterRelay: "Relays",
  filterReport: "Reports",
  filterReminder: "Reminders",
  filterAlert: "Alerts",
  // the pane header's second line
  fromRelay: "From {name} · your replies go back to them",
  aRelay: "A relay",
  yourReminder: "Your reminder",
  inChannel: "In #{slug}",
  fromPersonal: "From your chat with Vantage",
  fromDm: "From a direct message",
  fromVantage: "From Vantage",
  // empty states, per chip
  emptyAllTitle: "Nothing here yet",
  emptyAllBody: "Reports you asked for, messages passed on to you and your reminders land here.",
  emptyUnreadTitle: "All caught up",
  emptyUnreadBody: "Nothing unread.",
  emptyRelayTitle: "No relays",
  emptyRelayBody: "When someone asks Vantage to tell you something, it's here.",
  emptyReportTitle: "No reports",
  emptyReportBody: "When a report you asked for is ready, it lands here.",
  emptyReminderTitle: "No reminders",
  emptyReminderBody: "Ask Vantage to remind you, and it lands here.",
  emptyAlertTitle: "No alerts",
  emptyAlertBody: "Alerts from automations land here.",
};
